<template>
  <div class="notification-list" ref="notificationList"></div>
</template>

<script>
import {Appointment} from "../../entities/Appointment";
import {Event} from "../../entities/Event";
import DueAppointmentNotification from "./Appointments/DueAppointmentNotification"
import MissedVideoCallNotification from "./MissedVideoCall/MissedVideoCallNotification";
import DueEventNotification from "./Events/DueEventNotification";
import {createApp, reactive} from 'vue';
import {isDefined} from "../../utils";
import {MissedVideoCall} from "./MissedVideoCall/MissedVideoCall";
import i18n from "../..//i18n";
import {logger} from "../../main";

export default {
  name: "NotificationComponent",
  components: {DueAppointmentNotification, MissedVideoCallNotification, DueEventNotification},
  methods: {
    //Entity need to extend BaseVueEntity or have vueId Property
    addNotification(entity) {
      let component = undefined;
      if (entity instanceof Appointment) {
        const props = reactive({appointment: entity})
        component = createApp(DueAppointmentNotification, props);
      } else if (entity instanceof MissedVideoCall) {
        const props = reactive({userData: entity.userData})
        component = createApp(MissedVideoCallNotification, props);
      } else if (entity instanceof Event) {
        const props = reactive({event: entity})
        component = createApp(DueEventNotification, props);
      }
      if (component === undefined) {
        logger.error("Component is undefined.")
        return;
      }
      this.addNotificationToDom(component, entity);
    },
    addNotificationToDom(component, entity) {
      component.use(i18n)
      const div = document.createElement('div');
      this.$refs.notificationList.appendChild(div);
      const e = component.mount(div);
      e.$el.setAttribute('id', entity.vueId);
      const closeButton = document.createElement('div');
      closeButton.onclick = this.closeNotification;
      closeButton.classList.add('notification-close-button');
      e.$el.insertBefore(closeButton, e.$el.firstChild);
    },
    closeNotification(event) {
      this.$refs.notificationList.removeChild(event.target.parentNode.parentNode);
    },
    //VueId of Entity
    closeNotificationByVueId(vueId) {
      const e = document.getElementById(vueId);
      if (isDefined(e)) {
        this.$refs.notificationList.removeChild(e.parentNode);
      }
    }
  }
}
</script>
